import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default {
  namespaced: true,

  state: () => {
    return {};
  },

  actions: {
    async getLongLivedKeys({dispatch}, parameters) {
      // get all long lived keys as list of objects
      let response = await dispatch(
        'apiRequest',
        {
          method: 'get',
          apiUrl: '/apikeys',
          data: parameters,
        }
      );

      if (response.error) {
        console.log('api error', response);
        return null;
      }

      return response.data.keys;
    },

    async createLongLivedKey({dispatch}, parameters) {
      // Creates a long lived key.
      // params: {
      //     "tag": a user specified key identifier
      //     "exp": key expiry date (this value must be in seconds since epoch e.g. Unix Time)
      // }

      let response = await dispatch(
        'apiRequest',
        {
          method: 'post',
          apiUrl: '/apikeys',
          data: parameters,
        }
      );

      if (response.error) {
        console.log('api error', response);
        return null;
      }

      // response example:
      // {
      //   "expires": 0,
      //   "apikeyId": "---",
      //   "keyTag": "Test key 1",
      //   "apikeySecret": "---",
      //   "user_id": "auth0|---"
      // }
      return response.data;
    },

    async deleteLongLivedKey({dispatch}, parameters) {
      // Deletes a long lived key by a given "apikeyId" (in url)

      let response = await dispatch(
        'apiRequest',
        {
          method: 'delete',
          apiUrl: `/apikeys/${parameters.apikeyId}`,
        }
      );

      if (response.error) {
        console.log('api error', response);
        return null;
      }

      return true;
    },

    async apiRequest(store, parameters) {
      // here you can override common API request parameters for this api module
      // for example:
      // parameters: {...parameters, baseUrl: process.env.VUE_APP_BETA_API_URL},
      return store.dispatch(
        'api/apiRequest',
        {...parameters, baseUrl: process.env.VUE_APP_BETA_API_URL_V2},
        { root: true },
      );
    },
  },
}
